module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [(_vm.productSalesSelectProducts != null && this.headers.length == 8) ? _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.productSalesSelectProducts,
      "rows-per-page-items": [20, 40, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          domProps: {
            "innerHTML": _vm._s(_vm.fncFilterName(props.item.name))
          }
        }, [_vm._v(_vm._s(_vm.fncFilterName(props.item.name)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.uom))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncAveragePrice(props.item.gross, props.item.quantity)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.gross)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.nett)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewDates(props.item.products)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("shopping_cart")])])])]
      }
    }], null, false, 2709358508)
  }) : _vm._e(), _vm._v(" "), (_vm.dateList != null && this.headers.length == 11) ? _c('p', [_c('strong', [_vm._v(_vm._s(_vm.productFilter))])]) : _vm._e(), _vm._v(" "), (_vm.dateList != null && this.headers.length == 11) ? _c('v-data-table', {
    staticClass: "elevation-1",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.dateList,
      "rows-per-page-items": [20, 40, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quote_no))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.tender_status))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.originator_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.customer_name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.gross_total)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.discount_total)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.nett_total)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncViewQuote(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("list_alt")])])])]
      }
    }], null, false, 1420817401)
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.productSalesSelectProducts != null && this.headers.length == 11) ? _c('v-btn', {
    staticClass: "text-xs-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncResetProducts()
      }
    }
  }, [_vm._v("Reset Products")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}